import { DocumentType } from './DocumentType';

export class DocumentTemplate {
  id?: number;
  name?: string;
  documentType?: DocumentType;
  documentSize?: string;

  constructor(opts?: Partial<DocumentTemplate>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.documentType != null) {
      if (typeof opts.documentType === 'string') {
        this.documentType = DocumentType[opts.documentType];
      } else {
        this.documentType = opts.documentType;
      }
    }
    if (opts?.documentSize != null) {
      this.documentSize = opts.documentSize;
    }
  }
}
